import { render } from "./approval.vue?vue&type=template&id=10bf11d0&bindings={}"
import script from "./approval.vue?vue&type=script&lang=ts"
export * from "./approval.vue?vue&type=script&lang=ts"
script.render = render

export default script